const base = require("./base");
// 使用代理，只要是“/”的就会默认使用代理，否则不走代理
module.exports = {
  ...base.apiFactory(),
  "productSku": "https://cj-oss-test.oss-cn-hangzhou.aliyuncs.com/", // 商品详情数据测试环境oss地址
  "productDetail": "https://cj-oss-test.oss-cn-hangzhou.aliyuncs.com/", // 商品详情数据测试环境oss地址
  "supplierInfo": "https://cj-oss-test.oss-cn-hangzhou.aliyuncs.com/", // 供应商信息oss地址
};
